import xphouse from '../../Assets/Images/xphouse.png';
import gamerdairy from '../../Assets/Images/gamerdairy.png';
import aces from '../../Assets/Images/aceslogo.png';
import draic from '../../Assets/Images/draic.png';
import collegeRanker from '../../Assets/Images/collegeranker.png';
import cpmc from '../../Assets/Images/cpmc.png';
import yttb from '../../Assets/Images/yttb.png';
import flipverse from '../../Assets/Images/flipverse.png';

export const ProjectsData = [
  {
    title: 'Xp House',
    link: 'https://spyware007.github.io/Xp-House/',
    imageSrc: xphouse,
    headline: 'Every experience is Unique!',
    description:
      ' The idea was to make a website where seniors could share their interviews and job experiences on this platform. Up until now, we have gotten 10+ Interview Experiences.',
    color: 'deepskyblue',
    width: '200px',
    height: '200px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: '#0b3842',
    textShadow: '1px 1px 1px #141b2a'
  },
  {
    title: 'YTTB',
    link: 'https://yttb.netlify.app/',
    imageSrc: yttb,
    headline: 'Bookmark Your Timelines',
    description:
      ' Bookmark the required timelines in a YouTube video so that you never have to hustle to find out that one event you are looking for when you are revisiting the video.',
    color: '#000',
    width: 'auto',
    height: '80px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: ''
  },
  {
    title: 'FlipVerse',
    link: 'https://github.com/spyware007/flipverse',
    imageSrc: flipverse,
    headline: 'Blockchain-based eCommerce warranty system using NFTs',
    description:
      ' Blockchain-based eCommerce warranty system using NFTs The objective is to replace the physical warranty and have block chain based warranty using NFT which will ensure authenticity and security.      ',
    color: '#07182F',
    width: 'auto',
    height: '80px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: ''
  },
  {
    title: 'The Gamer Dairy',
    link: 'https://the-gamer-diary.herokuapp.com/',
    headline: 'Game parlor management system!',
    description:
      'It is a Game Parlour management system that tracks the information of the total no. of players, time played, and total charges Its a completely based on the MERN stack.',
    imageSrc: gamerdairy,
    color: '#d6ff79',
    width: '140px',
    height: '140px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: '#0b3842',
    textShadow: '1px 1px 1px #141b2a'
  },
  {
    title: 'Draic DYPCOE',
    link: 'https://www.draicdypcoe.in/',
    headline: 'Official website of DRAIC-DYPCOE.',
    description:
      'As a part of this amazing community of DRAIC-DYPCOE, I got the chance to create its official website from scratch.',
    imageSrc: draic,
    color: 'linear-gradient(to right top, rgb(0, 1, 88), rgb(0, 0, 0))',
    width: '140px',
    height: '140px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: ''
  },

  {
    title: 'College Ranker',
    link: 'https://www.collegeranker.in/',
    headline: 'My first paid Internship Work/Project',
    description:
      'I worked as React Developer in CollegeRanker India and built their official website with Onkar Mathapati(Founder of CollegeRanker India)',
    imageSrc: collegeRanker,
    color: '#1A488E',
    width: '140px',
    height: '140px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: ''
  },
  {
    title: 'CPMC Official Website',
    link: 'https://github.com/CPMC-DYPCOE/cpmc-website',
    headline: 'Coding is Fun when Mentoring is done !',
    description: 'Competitive Programming and Mentorship Club',
    imageSrc: cpmc,
    color: '#1e1e1e',
    width: '200px',
    height: '200px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: ''
  },
  {
    title: 'Aces Website',
    link: 'https://aces-dypcoe.github.io/ACES-New-Website/',
    headline: 'Official Website of ACES-DYPCOE.',
    description:
      'As a team member at ACES-DYPCOE, I with my fellowmates created the official website of ACES to manage and showcase the event!',
    imageSrc: aces,
    color: '#00FFFF',
    width: '140px',
    height: '140px',
    tags: ['reactjs', 'nodejs', 'expressjs', 'git', 'github'],
    fontColor: '#000036',
    textShadow: '1px 1px 1px #000036'
  }
];
